import { SessionModeEnum } from '@/enums/SessionModeEnum';

export default {
    title: 'Session',
    buttons: {
        start: 'Start Session',
        end: ({ values }: { values: { mode: SessionModeEnum } }) => {
            const { mode } = values;
            return mode === SessionModeEnum.SELF ? 'End Self-study' : 'End Session';
        },
        exit: 'Exit',
        review: 'Review',
        pause: 'Pause',
        resume: 'Resume',
        selfModeDoneConfirm:
            "Would you like to end self-study?<br />If there are students who haven't finished yet, their progress so far will be saved.",
        selfDoneConfirm:
            'Self-study is still in progress. Would you like to end it now?<br />Your learning progress will be saved even if you end now.',
        selfDoneConfirmMessage: 'Self-study Mode completed!',
        goStudentPage: 'Go to Waiting Room',
    },
    modal: {
        title: {
            ongoing: 'Activity In Progress',
            completed: 'End Session',
        },
        message: {
            ongoing: 'Ending the session will also end the activity in progress.\nWould you like to end?',
            completed: 'Would you like to end the session?',
        },
    },
    status: {
        ongoing: 'In Progress',
        completed: 'Completed',
        paused: 'Paused',
        preparing: 'Preparing',
        waiting: 'Waiting',
    },

    timer: {
        format: '{minutes}:{seconds}',
        started: 'Started at {time}',
        duration: '{duration} min elapsed',
    },

    students: {
        online: 'Online',
        offline: 'Offline',
        total: 'Total',
        count: '{count}',
        countFormat: '{online}/{total}',
        selectAll: 'Select All',
        selected: 'Selected',
        unselected: 'Deselected',
        notSubmitted: 'Students Not Submitted',
    },

    screen: {
        toggle: 'Board Screen',
        on: 'ON',
        off: 'OFF',
        options: {
            none: 'None',
            basic: 'Home Screen',
            waitingRoom: 'Waiting Room',
            activity: 'Activity Screen',
            sessionResult: 'Session Result Screen',
            moduleResult: 'Activity Result Screen',
        },
    },

    focus: {
        toggle: 'Focus Mode',
        on: 'Focus Mode On',
        off: 'Focus Mode Off',
    },

    star: {
        title: 'Praise Star',
        give: 'Give Praise Star',
        comment: 'Praise Message',
        comments: {
            great: 'Great job!',
            excellent: 'Excellent!',
            good: 'Good!',
            perfect: 'Perfect!',
            amazing: 'Amazing!',
        },
    },

    module: {
        start: 'Start Activity',
        end: 'End Activity',
        setting: 'Activity Settings',
        preview: 'Preview',
        result: 'View Results',
        inProgress: 'Activity In Progress',
        completed: 'Activity Completed',
        fold: 'Fold Writing Prompt',
        subject: 'Writing Prompt',
    },

    navigation: {
        home: 'Home',
        waitingRoom: 'Waiting Room',
        result: 'View Results',
        next: 'Next Activity',
        previous: 'Previous Activity',
    },
};
